
import MonitorApi from './src/Monitor'
import RegionApi from './src/Region'
import EquipmentApi from './src/Equipment'
import SwiperVideoApi from './src/SwiperGet'
import SwiperListApi from './src/SwiperPost'
import PassengerFlowApi from './src/PassengerFlowApi'
import HuaweiOpenApi from './src/HWCamera'

let apis = {
   MonitorApi,
   RegionApi,
   EquipmentApi,
   SwiperVideoApi,
   SwiperListApi,
   PassengerFlowApi,
   HuaweiOpenApi
};

export default apis;
